import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { formatNumber } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { obtenerAsesoria, limpiarAsesoria, editarAsesoria } from '../../actions/asesorias';
import { buscarClientesEmpresas, obtenerCliente, limpiarCliente } from '../../actions/clientes';

const EditarAsesoria = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Asesorías',
            path: '/asesorias'
        },
        {
            activo: true,
            nombre: 'Editar asesoría',
            path: '/asesorias/editar'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { id } = useParams();

    const { detalles } = useSelector(state => state.asesorias);
    const { listado_avanzado, detalles: detalles_cliente } = useSelector(state => state.clientes);

    const [asesoriaData, setAsesoriaData] = useState({
        id: null,
        cliente: null,
        motivo: null, 
        fecha: null, 
        descripcion: null
    });

    const [busquedaData, setBusquedaData] = useState({
        cliente: null,
        empresa: null
    });

    const [clientes, setClientes] = useState([]);

    const [clienteData, setClienteData] = useState({
        informacion_personal: {
            _id: null,
            nombre: null,
            nacimiento : null,
            celular: null,
            email: null,
            creacion: null,
            status: false
        },
        informacion_empresarial: {
            nombre_comercial: null, 
            razon_social: null, 
            rfc: null, 
            curp: null, 
            curp: null, 
            tipo_persona: null, 
            regimen_fiscal: null, 
            giro: null, 
            representante_legal: null, 
            puesto: null, 
            domicilio_fiscal: null, 
            telefono: null, 
            email: null, 
            web: null, 
            fecha_constitucion: null, 
            numero_empleados: null, 
            minimo_ingresos_anuales: null, 
            maximo_ingresos_anuales: null
        }
    });

    const { informacion_personal, informacion_empresarial } = clienteData;

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre || '-'
        },
        {
            name: 'Apellido Paterno',
            sortable: true, 
            selector: row => row.apellido_paterno || '-'
        },
        {
            name: 'Apellido Materno',
            sortable: true, 
            selector: row => row.apellido_materno || '-'
        },
        {
            name: 'Celular',
            sortable: true, 
            selector: row => row.celular || '-'
        },
        {
            name: 'Email',
            sortable: true, 
            selector: row => row.email || '-'
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleSeleccionarCliente(row)}><i className="fas fa-square-check text-link"></i></button>
                    </div>
                )
            }
        }
    ];

    /* Editar asesoría */
    const handleBusquedaChange = ({ target }) => {
        setBusquedaData({
            ...busquedaData,
            [target.name]: target.value
        });
    }

    const handleInputChange = ({ target }) => {
        setAsesoriaData({
            ...asesoriaData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setAsesoriaData({
            ...asesoriaData,
            [name]: value
        });
    }

    const handleReelegirCliente = async () => {
        dispatch(limpiarCliente());

        setAsesoriaData({
            ...asesoriaData,
            cliente: null
        });
    }

    const handleBuscarClientes = async () => {
        if(busquedaData.cliente || busquedaData.empresa){
            dispatch(buscarClientesEmpresas(busquedaData));
        }else{
            dispatch(setAlert('Es necesario el cliente o la empresa para la búsqueda', 'danger'));
        }
    }

    const handleSeleccionarCliente = (cliente) => {
        if(cliente){
            dispatch(obtenerCliente(cliente._id));

            setAsesoriaData({
                ...asesoriaData,
                cliente: cliente._id
            });

            setBusquedaData({
                cliente: '',
                empresa: ''
            });

            setClientes([]);
        }else{
            dispatch(setAlert('El cliente no puede ser elegido', 'danger'));
        }
    }

    const handleEditarAsesoria = async () => {
        if(asesoriaData.cliente && asesoriaData.motivo && asesoriaData.fecha){
            await dispatch(editarAsesoria(asesoriaData));

            await navigate("/asesorias");
        }else{
            await dispatch(setAlert('Todos los campos son obligatorios', 'danger'));
        }
    }

    useEffect(() => {
        dispatch(limpiarAsesoria());
        dispatch(limpiarCliente());
        dispatch(buscarClientesEmpresas(null));

        return () => {
            dispatch(limpiarAsesoria());
            dispatch(limpiarCliente());
            dispatch(buscarClientesEmpresas(null));
        }
    }, []);

    useEffect(() => {
        dispatch(obtenerAsesoria(id));

        if(id){
            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        setClientes(listado_avanzado);
    }, [listado_avanzado]);

    useEffect(() => {
        if(detalles_cliente){
            setClienteData({
                ...clienteData,
                informacion_personal: {
                    ...detalles_cliente.informacion_personal
                }, 
                informacion_empresarial: {
                    ...detalles_cliente.informacion_empresarial
                }
            });
        }
    }, [detalles_cliente]);

    useEffect(() => {
        setAsesoriaData({
            ...asesoriaData,
            id: detalles?._id,
            cliente: detalles?.cliente?._id,
            motivo: detalles?.motivo,
            fecha: detalles?.creacion,
            descripcion: detalles?.descripcion
        });

        if(detalles?.cliente){
            setClienteData({
                ...clienteData,
                informacion_personal: {
                    ...detalles?.cliente?.informacion_personal
                }, 
                informacion_empresarial: {
                    ...detalles?.cliente?.informacion_empresarial
                }
            });
        }
    }, [detalles]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Editar asesoría</h3>
                
                    <div className="row">
                        <div className="col-md-12">
                            <div className="accordion" id="accordionNuevo">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Información del cliente
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-5 form-group mb-3">
                                                {
                                                    !asesoriaData.cliente &&
                                                        <div className="input-group">
                                                            <div className="form-floating">
                                                                <input type="text" className="form-control" placeholder="Buscar por cliente" id="cliente" name="cliente" value={busquedaData.cliente} onChange={e => handleBusquedaChange(e)}/>
                                                                <label htmlFor="cliente">Buscar por cliente</label>
                                                            </div>
                                                        </div>
                                                }
                                            </div>

                                            <div className="col-md-5 form-group mb-3">
                                                {
                                                    !asesoriaData.cliente &&
                                                        <div className="input-group">
                                                            <div className="form-floating">
                                                                <input type="text" className="form-control" placeholder="Buscar por empresa" id="empresa" name="empresa" value={busquedaData.empresa} onChange={e => handleBusquedaChange(e)}/>
                                                                <label htmlFor="empresa">Buscar por empresa</label>
                                                            </div>
                                                        </div>
                                                }
                                            </div>

                                            <div className="col-md-2 form-group text-center mb-3">
                                                {
                                                    asesoriaData.cliente ?
                                                        <button className="btn btn-warning" onClick={handleReelegirCliente}>Elegir otro cliente</button>
                                                    :
                                                        <button className="btn btn-primary" onClick={handleBuscarClientes}>Buscar coincidencias</button>
                                                }
                                            </div>
                                            
                                            {
                                                asesoriaData.cliente ? (
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Nombre</label>
                                                            <p>{[informacion_personal?.nombre, informacion_personal?.apellido_paterno, informacion_personal?.apellido_materno].join(' ')}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Celular</label>
                                                            <p>{informacion_personal?.celular ? <>{informacion_personal.celular} <a href={`https://wa.me/${informacion_personal.celular.replace(/\D/g, '')}`} target="_blank" rel="noreferrer"><i className="fab fa-whatsapp text-success"></i></a></> : 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Email</label>
                                                            <p>{informacion_personal?.email || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Fecha de nacimiento</label>
                                                            <p>{informacion_personal?.nacimiento ? new Date(informacion_personal?.nacimiento).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Fecha de registro</label>
                                                            <p>{informacion_personal?.creacion ? new Date(informacion_personal?.creacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                                        </div>

                                                        <hr />

                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Nombre comercial</label>
                                                            <p>{informacion_empresarial?.nombre_comercial || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Razón social</label>
                                                            <p>{informacion_empresarial?.razon_social || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">RFC</label>
                                                            <p>{informacion_empresarial?.rfc || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">CURP</label>
                                                            <p>{informacion_empresarial?.curp || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Tipo de persona</label>
                                                            <p>{informacion_empresarial?.tipo_persona || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Régimen fiscal</label>
                                                            <p>{informacion_empresarial?.regimen_fiscal?.nombre || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Actividad empresarial</label>
                                                            <p>{informacion_empresarial?.giro?.nombre || 'Sin definir'}</p>
                                                        </div>
                                                        
                                                        <hr />
            
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Representante legal</label>
                                                            <p>{informacion_empresarial?.representante_legal || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Puesto</label>
                                                            <p>{informacion_empresarial?.puesto || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Domicilio fiscal</label>
                                                            <p>{informacion_empresarial?.domicilio_fiscal || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Teléfono</label>
                                                            <p>{informacion_empresarial?.telefono || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Correo</label>
                                                            <p>{informacion_empresarial?.email || 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Sitio web</label>
                                                            <p>{informacion_empresarial?.web ? (<a target='_blank' href={informacion_empresarial?.web}>{informacion_empresarial?.web}</a>) : ('Sin definir')}</p>
                                                        </div>
            
                                                        <hr />
            
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Fecha de constitución</label>
                                                            <p>{informacion_empresarial?.fecha_constitucion ? new Date(informacion_empresarial?.fecha_constitucion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Número de empleados</label>
                                                            <p>{informacion_empresarial?.numero_empleados ? formatNumber(informacion_empresarial?.numero_empleados, 0, '', '') : 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Mínimo de ingresos anuales</label>
                                                            <p>{informacion_empresarial?.minimo_ingresos_anuales ? formatNumber(informacion_empresarial?.minimo_ingresos_anuales, 0, '$', '') : 'Sin definir'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="fw-bold">Máximo de ingresos anuales</label>
                                                            <p>{informacion_empresarial?.maximo_ingresos_anuales ? formatNumber(informacion_empresarial?.maximo_ingresos_anuales, 0, '$', '') : 'Sin definir'}</p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <hr className="my-3" />

                                                        {
                                                            clientes.length == 0 ?
                                                                <div className="col-md-5 form-group text-center w-100 mb-3">
                                                                    <h6 className="text-center w-100">Elige un cliente para crear una nueva asesoría.</h6>
                                                                </div>
                                                            :
                                                                <div className="mt-0">
                                                                    <DataTable
                                                                        columns={columns}
                                                                        data={clientes}
                                                                        noDataComponent="Aún no hay registros"
                                                                        pagination
                                                                        paginationPerPage={20}
                                                                        paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                                                        paginationComponentOptions={paginationOptions}
                                                                        highlightOnHover={true}
                                                                    />
                                                                </div>
                                                        }
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                            Información de la asesoría
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-9 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Motivo" id="motivo" name="motivo" value={asesoriaData.motivo} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="motivo">Motivo</label>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <DatePicker
                                                            id="fecha"
                                                            name="fecha"
                                                            className="form-control text-center input-datepícker"
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="es-ES"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={ asesoriaData.fecha != null ? new Date(asesoriaData.fecha) : '' }
                                                            onChange={ date => handleDatePicker('fecha', date) }
                                                        />
                                                        <label className="label-datepicker" htmlFor="fecha">Fecha de creación</label>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-12 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <textarea className="form-control textareaCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={asesoriaData.descripcion} onChange={e => handleInputChange(e)}></textarea>
                                                        <label htmlFor="descripcion">Descripción</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleEditarAsesoria}>Guardar</button>
                            <Link to='/asesorias'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default EditarAsesoria;